import client from '@libs/HttpClient';
class MyAllTasksService {
  //My All Task Master
  static listMyAllTasks(request) {
    const page_no = request.queryKey[1];
    const selectedTab = request.queryKey[2];
    const selectedEmployee = request.queryKey[3];
    const selectedInactiveEmployee = request.queryKey[4];
    const selectedProject = request.queryKey[5];
    const selectedSprint = request.queryKey[6];
    return client.get(
      `/myalltasks?page=${page_no}&projectIds=${selectedProject}&sprintIds=${selectedSprint}&employeeId=${selectedEmployee}&inactiveEmployeeId=${selectedInactiveEmployee}&statusType=${selectedTab}`,
      request
    );
  }
  static getEmployees(request) {
    return client.get(
      `/myalltasks/all-employees`,
      request
    );
  }
  static getInactiveEmployees(request) {
    return client.get(
      `/myalltasks/all-inactive-employees`,
      request
    );
  }
  static projectList(request) {
    return client.get(
      `/myalltasks/all-projects`,
      request
    );
  }
  static sprintList(request) {
    return client.get(
      `/myalltasks/all-sprints/${request.project_id}`,
      request
    );
  }
}
export { MyAllTasksService };
